import React from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

export default function CollectionHelp({ children }) {
  const [open, setOpen] = React.useState(false);
  return (
    <Tooltip
      title={children}
      describeChild
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    >
      <IconButton
        aria-label="About this change"
        size="small"
        onClick={() => setOpen(true)}
        onKeyDown={(event) => {
          if (event.key === "Escape" && open) {
            event.stopPropagation();
            setOpen(false);
          }
        }}
      >
        <InfoOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
